const ProductCarousel = {
  SELECTORS: {
    container: '[data-js-product-carousel]',
  },
  init() {
    this.initializeCarousels(document);
  },
  initializeCarousels(parentElement) {
    const containerElements = parentElement.querySelectorAll(this.SELECTORS.container);

    containerElements.forEach((containerElement) => {
      new Swiper(containerElement, {
        slidesPerView: 'auto',
        mousewheel: {
          forceToAxis: true,
        },
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
        watchOverflow: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  ProductCarousel.init();
});

document.addEventListener('shopify:section:load', () => {
  ProductCarousel.init();
});

document.addEventListener('shopify:section:reorder', () => {
  ProductCarousel.init();
});

window.ProductCarousel = ProductCarousel;
